(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rootplus-medical-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-play-expert]').forEach(function(button){button.addEventListener('click',function(){var target=button.closest('.rpm-doctor-hero');var video=target.querySelector('video');video.muted=false;video.loop=false;video.controls=true;target.classList.add('is-playing');video.play().catch(function(){})})});
document.querySelectorAll('.rpm video').forEach(function(video){video.addEventListener('play',function(){document.querySelectorAll('.rpm video').forEach(function(other){if(other!==video)other.pause()})})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rootplus-shampoo"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    const form = root.querySelector('.rpsh-buy form');
    if (!form || form.dataset.addonReady) return;
    form.dataset.addonReady = 'true';
    const addon = form.querySelector('[data-addon]');
    if (!addon) return;
    form.addEventListener('submit', async event => {
      if (!addon.checked) return;
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (button.disabled) return;
      button.disabled = true;
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:Number(form.querySelector('[name="id"]').value),quantity:1},{id:Number(addon.value),quantity:1}]})
        });
        if (!response.ok) throw new Error('cart');
        window.location.assign(form.querySelector('[name="return_to"]').value);
      } catch {
        button.disabled = false;
        let message = form.querySelector('[data-addon-error]');
        if (!message) {
          message = document.createElement('p');
          message.dataset.addonError = '';
          message.setAttribute('role','alert');
          button.appendChild(message);
        }
        message.textContent = 'לא הצלחנו להוסיף את שני המוצרים. נסו שוב או הסירו את הסימון מהרול־און.';
      }
    });
  };
  document.querySelectorAll('.rpsh').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.rpsh').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rootplus-site-header"] && !Shopify.designMode) return;
  try {
    
  (()=>{document.querySelectorAll('[data-rph]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const button=root.querySelector('[data-rph-menu]');const panel=root.querySelector('[data-rph-panel]');button?.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!open));panel.hidden=open})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rootplus-studio"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.querySelector('.rps-form');
      const radios = [...form.querySelectorAll('input[name="id"]')];
      const addon = form.querySelector('[data-addon]');
      if (addon) form.addEventListener('submit', async event => {
        if (!addon.checked) return;
        event.preventDefault();
        const chosen = radios.find(input => input.checked && !input.disabled);
        const button = form.querySelector('button[type="submit"]');
        if (!chosen || button.disabled) return;
        button.disabled = true;
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST', headers: {'Content-Type':'application/json'},
            body: JSON.stringify({items:[{id:Number(chosen.value),quantity:1},{id:Number(addon.value),quantity:1}]})
          });
          if (!response.ok) throw new Error('cart');
          window.location.assign(form.querySelector('input[name="return_to"]').value);
        } catch {
          button.disabled = false;
          let message = form.querySelector('[data-addon-error]');
          if (!message) {
            message = document.createElement('p');
            message.dataset.addonError = '';
            message.setAttribute('role','alert');
            button.insertAdjacentElement('afterend', message);
          }
          message.textContent = 'לא הצלחנו להוסיף את שני המוצרים. נסו שוב או הסירו את הסימון מהשמפו.';
        }
      });
      const price = root.querySelector('[data-sticky-price]');
      const sync = () => {
        const selected = radios.find(input => input.checked && !input.disabled);
        if (!selected) return;
        price.textContent = selected.dataset.price;
        const summary = form.querySelector('[data-selection]');
        const selectedPrice = new Intl.NumberFormat('he-IL',{style:'currency',currency:'ILS'}).format(Number(selected.dataset.cents) / 100);
        summary.textContent = selected.dataset.label + ' · ' + selectedPrice + (addon?.checked ? ' + שמן טיפוח לילה ב־99 ₪ בהטבה; הסכום הסופי בסל' : '') + ' · ' + root.dataset.shippingLabel;
        const url = new URL(location.href);
        url.searchParams.set('variant', selected.value);
        history.replaceState(history.state, '', url.toString());
      };
      form.addEventListener('change', sync);
      sync();
      const sticky = root.querySelector('[data-sticky]');
      const offer = root.querySelector('.rps-offer');
      const stickyObserver = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting;
      }, {threshold:0});
      stickyObserver.observe(offer);

    };
    document.querySelectorAll('[data-studio]').forEach(init);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-studio]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();
})();
